import { useQuery } from "@tanstack/react-query";

import getEgressIPs from "@/api/services/egress_ips.ts";

export function useEgressIPs() {
  return useQuery({
    queryKey: ["egress-ips"],
    queryFn: () => getEgressIPs(),
  });
}
